import { Injectable } from '@angular/core';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';
import { optionColorPipe } from '@df/ui/common/option-color.pipe';
import { optionLabelPipe } from '@df/ui/common/option-label.pipe';
import { EListingLabelOptionId, IProductLabel, NProductViewLayout, Product } from './product.decorator';
export const SPECIFICATION_ATTRIBUTES_CODES = [
    'variant_attribute_1',
    'variant_attribute_2',
    'variant_attribute_3',
    'variant_attribute_4',
    'variant_attribute_5'
];
@Injectable({
    providedIn: 'root'
})
export class ProductService {
    constructor(private attributeResource: AttributeResource) {}
    getAttributeItem(code: string, product: Product): NProductViewLayout.IAttributeItem | undefined {
        const attribute = this.attributeResource.getExisting(code);
        if (!attribute) {
            return undefined;
        }
        const values = product.getAttr<number | string | (number | string)[]>(code);
        if (!values) {
            return undefined;
        }
        const valuesArray = (Array.isArray(values) ? values : [values]).filter(i => !!i);
        if (!valuesArray.length) {
            return;
        }
        const isText = !!attribute.data?.frontend_input && ['text'].includes(attribute.data.frontend_input);
        const isTextArea = !!attribute.data?.frontend_input && ['textarea'].includes(attribute.data.frontend_input);
        const valuesLabels = isText || isTextArea ? valuesArray as string[] : valuesArray.map(i => attribute.getOptionLabel(i) as string);
        if (SPECIFICATION_ATTRIBUTES_CODES.indexOf(code) > -1) {
            const firstValue = valuesLabels[0];
            if (typeof firstValue === 'string') {
                const parts = firstValue.split('|');
                if (parts.length === 2) {
                    return {
                        label: parts[0],
                        valuesLabels: [parts[1]],
                        code,
                        isText: false,
                        isTextArea: false
                    };
                }
            }
            return undefined;
        }
        return {
            // code,
            isText,
            isTextArea,
            label: attribute.data?.label || '',
            code,
            valuesLabels
        };
    }
    getListingLabelProductLabel(optionId: EListingLabelOptionId): IProductLabel | undefined {
        const label = optionLabelPipe(optionId, 'listing_label') as string | undefined;
        if (label) {
            return {
                label,
                color: optionColorPipe(optionId, 'listing_label')
            };
        }
        return undefined;
    }
}
